import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Guardar imagen secundaria de la empresa.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} payload: información para el registro.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function store({ commit }, payload) {
  commit('dashboard/load', true, { root: true });

  await $http.post("companies/images", payload)
    .then(({ data: response }) => {

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Imagen secundaria',
        text: response.message,
        showConfirmButton: true
      })

      setDataCompleted(commit, response)

    })
    .catch(errors => {

      // Errores de validaciones
      if (controlErrorsCallback(errors)) return false;

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Imagen secundaria',
        text: 'Ups, ocurrió un error al tratar de guardar la imagen secundaria de la empresa.',
        showConfirmButton: true
      })

    })
    .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Cargar imagen secundaria de la empresa.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} companyId: identificador de la empresa.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function getByCompanyId({ commit }, companyId) {
  commit('dashboard/load', true, { root: true });

  await $http.get(`companies/images/${companyId}`)
    .then(({ data: response }) => setDataCompleted(commit, response))
    .catch(() => {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Imagen secundaria',
        text: 'Ups, ocurrió un error al tratar de cargar la imagen secundaria de la empresa.',
        showConfirmButton: true
      })

    })
    .finally(() => commit('dashboard/load', false, { root: true }));
}

function setDataCompleted(commit, { data: response }) {
  
  commit('resetImgPreviewPath');
  commit('resetSecondaryImage');

  if (!response) return false;

  const services = [];

  if (response.apply_service_dashboard == 1) services.push('dashboard');
  if (response.apply_service_fds == 1) services.push('fds');
  if (response.apply_service_inventory == 1) services.push('inventory');
  if (response.apply_service_labels == 1) services.push('labels');

  if (response.image) commit('setImgPreviewPath', `${process.env.VUE_APP_API_URL}${response.image}`);
  commit('setSecondaryImage', { image: null, services });
}

/**
 * Controlar los errores de validaciones del filtro.
 *
 * @param {object} errors
 * @returns {boolean}
 * @author Fernando Claros
 */
function controlErrorsCallback(errors) {
  try {

    if ('errors' in errors && typeof errors.errors === 'object' && errors.status == 422) {

      let errorsText = "<ul><li style='list-style: none;'>Algunos de los parámetros enviados son inválidos.</li>";
      Object.values(errors.errors).forEach(item => errorsText += `<li style='font-size: 16px;' class='text-left;'><i>${item}</i></li>`);
      errorsText += "</ul>";

      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Imagen secundaria',
        html: errorsText,
        showConfirmButton: true
      });

      return true;
    }

    return false;

  } catch (e) {
    return false;
  }
}